// We list the icons we use explicitly because this reduces our bundle size.

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library, config } from '@fortawesome/fontawesome-svg-core'
import {
  faAddressBook,
  faArrowCircleLeft,
  faArrowCircleRight,
  faAngleRight,
  faAngleDoubleDown,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faBabyCarriage,
  faBalanceScaleLeft,
  faBan,
  faBars,
  faBath,
  faBed,
  faBell,
  faBicycle,
  faBinoculars,
  faBookOpen,
  faBriefcase,
  faBug,
  faBullhorn,
  faCalculator,
  faCamera,
  faCar,
  faCaretUp,
  faCaretDown,
  faChartBar,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faChevronCircleDown,
  faChevronCircleRight,
  faChevronCircleUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCirclePlus,
  faClipboard,
  faClock,
  faCloud,
  faCoffee,
  faCog,
  faComment,
  faComments,
  faCalendarAlt,
  faCopy,
  faCrown,
  faDownload,
  faEllipsisH,
  faEnvelope,
  faEquals,
  faEraser,
  faExclamationTriangle,
  faExpand,
  faEye,
  faEyeSlash,
  faFileExcel,
  faFilter,
  faFlag,
  faFolderOpen,
  faFrown,
  faGavel,
  faGift,
  faGlassMartini,
  faGlobeEurope,
  faHammer,
  faHandHoldingHeart,
  faHandPaper,
  faHandsHelping,
  faHandshake,
  faHashtag,
  faHatWizard,
  faHeadphones,
  faHeart,
  faHistory,
  faHome,
  faImage,
  faInfoCircle,
  faLaptop,
  faLeaf,
  faLink,
  faList,
  faLock,
  faLockOpen,
  faMap,
  faMapMarkerAlt,
  faMeh,
  faMinus,
  faMinusCircle,
  faMobileAlt,
  faPaperPlane,
  faPause,
  faLightbulb,
  faRobot,
  faCircleExclamation,
  faPen,
  faPencil,
  faPlay,
  faPlus,
  faPrint,
  faQuestionCircle,
  faRedo,
  faReply,
  faSave,
  faSearch,
  faShareAlt,
  faShieldAlt,
  faShoppingCart,
  faSignOutAlt,
  faSlash,
  faSliders,
  faSmile,
  faSocks,
  faSpinner,
  faStar,
  faSync,
  faTabletAlt,
  faTag,
  faTimes,
  faThumbsDown,
  faThumbsUp,
  faThumbtack,
  faTimesCircle,
  faTrash,
  faTrashAlt,
  faTrophy,
  faTruck,
  faTv,
  faUmbrella,
  faUser,
  faUsers,
  faUtensils,
  faWalking,
} from '@fortawesome/free-solid-svg-icons'

import {
  faChrome,
  faDiscourse,
  faEdge,
  faFacebook,
  faFirefoxBrowser,
  faGithub,
  faInstagram,
  faLinkedin,
  faSafari,
  faTwitter,
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons'

// Prevent fontawesome from injecting CSS via JavaScript at runtime.
// The CSS is already loaded via nuxt.config.ts css array, so auto-injection
// causes duplicate styles and SSR hydration mismatches.
config.autoAddCss = false

library.add(
  faAddressBook,
  faAngleDoubleDown,
  faAngleDoubleLeft,
  faAngleDoubleRight,
  faAngleRight,
  faArrowCircleLeft,
  faArrowCircleRight,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowUp,
  faBabyCarriage,
  faBalanceScaleLeft,
  faBan,
  faBars,
  faBath,
  faBed,
  faBell,
  faBicycle,
  faBinoculars,
  faBookOpen,
  faBriefcase,
  faBug,
  faBullhorn,
  faCalculator,
  faCalendarAlt,
  faCamera,
  faCar,
  faCaretDown,
  faCaretUp,
  faChartBar,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faChevronCircleDown,
  faChevronCircleRight,
  faChevronCircleUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faCircle,
  faCirclePlus,
  faClipboard,
  faClock,
  faCloud,
  faCoffee,
  faCog,
  faComment,
  faComments,
  faCopy,
  faCrown,
  faDownload,
  faEllipsisH,
  faEnvelope,
  faEquals,
  faEraser,
  faExclamationTriangle,
  faExpand,
  faEye,
  faEyeSlash,
  faFileExcel,
  faFilter,
  faFlag,
  faFolderOpen,
  faFrown,
  faGavel,
  faGift,
  faGlassMartini,
  faGlobeEurope,
  faHammer,
  faHandHoldingHeart,
  faHandPaper,
  faHandsHelping,
  faHandshake,
  faHashtag,
  faHatWizard,
  faHeadphones,
  faHeart,
  faHistory,
  faHome,
  faImage,
  faInfoCircle,
  faLaptop,
  faLeaf,
  faLink,
  faList,
  faLock,
  faLockOpen,
  faMap,
  faMapMarkerAlt,
  faMeh,
  faMinus,
  faMinusCircle,
  faMobileAlt,
  faPaperPlane,
  faPause,
  faLightbulb,
  faRobot,
  faCircleExclamation,
  faPen,
  faPencil,
  faPlay,
  faPlus,
  faPrint,
  faQuestionCircle,
  faRedo,
  faReply,
  faSave,
  faSearch,
  faShareAlt,
  faShieldAlt,
  faShoppingCart,
  faSignOutAlt,
  faSlash,
  faSliders,
  faSmile,
  faSocks,
  faSpinner,
  faStar,
  faSync,
  faTabletAlt,
  faTag,
  faThumbsDown,
  faThumbsUp,
  faThumbtack,
  faTimes,
  faTimesCircle,
  faTrash,
  faTrashAlt,
  faTrophy,
  faTruck,
  faTv,
  faUmbrella,
  faUser,
  faUsers,
  faUtensils,
  faWalking,
  faChrome,
  faDiscourse,
  faEdge,
  faFacebook,
  faFirefoxBrowser,
  faGithub,
  faInstagram,
  faLinkedin,
  faSafari,
  faTwitter,
  faWhatsapp
)

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('VIcon', FontAwesomeIcon)
})
